<script lang="ts">
	import { _ } from "svelte-i18n";
	import { FormGroup, Input, Label } from "@sveltestrap/sveltestrap";
	import type { DropdownOption } from "../../../common/types";

	let { options, value = $bindable() }: { options: DropdownOption[]; value: string } = $props();
</script>

<FormGroup>
	<Label for="v2-text-generator">
		{$_("landingpage.newPresentation.textGenerator")}
	</Label>
	<Input type="select" id="v2-text-generator" bind:value>
		{#each options as opt (opt.value)}
			<option value={opt.value}>{opt.label}</option>
		{/each}
	</Input>
</FormGroup>
